import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setFullHeight } from '../../actions/uiActions';
import { RedirectAs404 } from '../Error404';
import GridCover from '../GridCover';


class GridCoverTitle extends Component {
  componentDidMount () {
    const { actions } = this.props;
    actions.setFullHeight(true);
  }

  render () {
    const { match, ...rest } = this.props;
    return (
      <Switch>
        <Route exact path={match.url} render={props => <GridCover {...rest} />} />
        <Route component={RedirectAs404} />
      </Switch>
    );
  }
}

GridCoverTitle.propTypes = {
  uid: PropTypes.string,
  name: PropTypes.string,
  slug: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ setFullHeight }, dispatch),
});

export default withRouter(connect(null, mapDispatchToProps)(GridCoverTitle));



// WEBPACK FOOTER //
// ./src/components/Title/GridCoverTitle.js